// import { Group, Text } from "@mantine/core";
// import React from "react";
// import InfoCircle from "../dataDisplay/infoCircle";

// export const WidgetTitleWithInfo = ({
//   text,
//   infoLink,
// }: {
//   text: string;
//   infoLink: string;
// }) => (
//   <Group gap="xs">
//     <Text size="sm">{text}</Text>
//     <InfoCircle infoLink={infoLink} />
//   </Group>
// );

import { Group, Text, Box, ActionIcon } from "@mantine/core";
import React from "react";
import InfoCircle from "../dataDisplay/infoCircle";
import { IconInfoCircle } from "@tabler/icons-react";
import { Cubby } from "../../stores/Cubby";
type TextWithInfoProps = {
  text: string;
  articleSlug: string;
  cubby: Cubby;
  textSize?: string;
  infoCircleNudge?: {
    vertical?: number;
    horizontal?: number;
  };
};

export const InfoLinkToDocsSlug: React.FC<TextWithInfoProps> = ({
  textSize = "md",
  text,
  articleSlug,
  cubby,
  infoCircleNudge = { vertical: 2, horizontal: -3 },
}) => (
  <Group gap="xs" justify="flex-start" wrap="nowrap">
    <Text size={textSize}>{text}</Text>

    <ActionIcon
      variant="subtle"
      size="sm"
      component="a"
      target="_blank"
      mt={infoCircleNudge.vertical}
      ml={infoCircleNudge.horizontal}
      onClick={() => cubby.setCurrentlyFocusedArticleSlug(articleSlug)}
      style={{
        color: "var(--mantine-color-dark-3)",
        marginLeft: "10rem",
      }}
      aria-label="Info"
    >
      <IconInfoCircle size={16} />
    </ActionIcon>
  </Group>
);
